@for (day of daysOfWeek; track daysOfWeek) {
  <div>
    <ng-container
      *ngIf="{
        crEnCoursDenvoiFilteredByDay: crEnCoursDenvoiFiltered | crOfDay: day,
        crFilteredByDay: crListUserFiltered | crOfDay: day,
      } as allCrFilteredByDay"
    >
      <div
        *ngIf="
          allCrFilteredByDay.crEnCoursDenvoiFilteredByDay.length > 0 || allCrFilteredByDay.crFilteredByDay.length > 0
        "
        padding
        class="top_title"
      >
        <span class="top_title_element">{{ day | date: 'dd MMMM yyyy' }} :</span>
        <span class="top_title_element">
          {{ allCrFilteredByDay.crEnCoursDenvoiFilteredByDay.length + allCrFilteredByDay.crFilteredByDay.length }}
        </span>
        <span class="top_title_element cr_title">
          CR
          <span
            *ngIf="
              allCrFilteredByDay.crEnCoursDenvoiFilteredByDay.length + allCrFilteredByDay.crFilteredByDay.length > 1
            "
          >
            s
          </span>
        </span>
        <span class="top_title_element">|</span>
        <span class="top_title_element">
          {{
            allCrFilteredByDay.crEnCoursDenvoiFilteredByDay
              | crTempsRealise: allCrFilteredByDay.crFilteredByDay
              | duration
          }}
        </span>
      </div>
      <cr-list-vue-jour
        [crEnCoursDenvoiFiltered]="allCrFilteredByDay.crEnCoursDenvoiFilteredByDay"
        [isDraftCrDeletionModeActive]="isDraftCrDeletionModeActive"
        (crEmitter)="goToCrDetails($event)"
        (crActiviteInterneEmitter)="goToCrActiviteInterneDetails($event)"
      ></cr-list-vue-jour>
      <cr-list-vue-jour
        [crListUserFiltered]="allCrFilteredByDay.crFilteredByDay"
        [isDraftCrDeletionModeActive]="isDraftCrDeletionModeActive"
        (crEmitter)="goToCrDetails($event)"
        (crActiviteInterneEmitter)="goToCrActiviteInterneDetails($event)"
      ></cr-list-vue-jour>
    </ng-container>
  </div>
}
